import axios from 'axios';
import dayjs from 'dayjs';
import { formatNumber } from './helper.js';

export async function GetMonitors(apikey, days) {

  const dates = [];
  const today = dayjs(new Date().setHours(0, 0, 0, 0));
  for (let d = 0; d < days; d++) {
    dates.push(today.subtract(d, 'day'));
  }

  const ranges = dates.map((date) => `${date.unix()}_${date.add(1, 'day').unix()}`);
  const start = dates[dates.length - 1].unix();
  const end = dates[0].add(1, 'day').unix();
  ranges.push(`${start}_${end}`);

  const postdata = {
    api_key: apikey,
    format: 'json',
    logs: 1,
    log_types: '1-2',
    logs_start_date: start,
    logs_end_date: end,
    custom_uptime_ranges: ranges.join('-'),
  };

  const makeRequest = async (retries = 3) => {
    try {
      const response = await axios.post('https://api.uptimerobot.com/v2/getMonitors', postdata, { timeout: 10000 });
      if (response.data.stat !== 'ok') throw response.data.error;
      return response.data.monitors.map((monitor) => {

        const ranges = monitor.custom_uptime_ranges.split('-');
        const average = formatNumber(ranges.pop());
        const daily = [];
        const map = [];
        dates.forEach((date, index) => {
          map[date.format('YYYYMMDD')] = index;
          daily[index] = {
            date: date,
            uptime: formatNumber(ranges[index]),
            down: { times: 0, duration: 0 },
          }
        });

        const total = monitor.logs.reduce((total, log) => {
          if (log.type === 1) {
            const date = dayjs.unix(log.datetime).format('YYYYMMDD');
            const dailyIndex = map[date];
            total.duration += log.duration;
            total.times += 1;
            if (dailyIndex !== undefined && daily[dailyIndex]) {
              daily[dailyIndex].down.duration += log.duration;
              daily[dailyIndex].down.times += 1;
            }
          }
          return total;
        }, { times: 0, duration: 0 });

        const result = {
          id: monitor.id,
          name: monitor.friendly_name,
          url: monitor.url,
          average: average,
          daily: daily,
          total: total,
          status: 'unknow',
        };

        if (monitor.status === 2) result.status = 'ok';
        if (monitor.status === 9) result.status = 'down';
        return result;
      });
    } catch (error) {
      if (error.response && error.response.status === 429 && retries > 0) {
        await new Promise(resolve => setTimeout(resolve, 5000)); // Wait 5 seconds
        return makeRequest(retries - 1);
      }
      throw error;
    }
  };

  return makeRequest();
}
